<template>
    <v-flex xs12>
        <v-container grid-list-lg>
            <v-form ref="formDadosCadastrais" v-model="formValidDadosCadastrais">
                <v-layout row wrap>
                    <v-flex xs12 sm6>
                        <v-text-field label="CNPJ"
                            id="txtDadosCadastraisCnpj"
                            ref="txtDadosCadastraisCnpjRef"
                            v-model="transportadora.cnpj"
                            mask="NN.NNN.NNN/NNNN-##"
                            disabled
                            ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6>
                        <v-text-field label="Razão Social"
                            id="txtDadosCadastraisRazaoSocial"
                            ref="txtDadosCadastraisRazaoSocialRef"
                            :rules="regras.nomeTransportadora"
                            v-model="transportadora.nome"
                            @change="alteracoes.nome = true"
                            :disabled="!permissaoAnalisaSolicitacao || model.status.id == estatusComputed.statusEnum.PROCESSAMENTO"></v-text-field>
                    </v-flex>

                    <v-flex xs12>
                        <small v-if="!preenchimentoEnderecoValido" class="error--text">Preencha todos os campos para alterar o endereço</small>
                    </v-flex>

                    <v-flex xs12 sm3>
                        <v-text-field label="CEP*"
                            id="txtDadosCadastraisCep"
                            ref="txtDadosCadastraisCepRef"
                            :rules="regras.cep"
                            v-model="transportadora.enderecos[0].cep"
                            :disabled="!permissaoAnalisaSolicitacao || model.status.id == estatusComputed.statusEnum.PROCESSAMENTO"
                            @change="carregaDadosGoogle()"
                            mask="#####-###"
                            validate-on-blur
                            ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm7>
                        <v-text-field label="Endereço*"
                        id="txtDadosCadastraisEndereco"
                        ref="txtDadosCadastraisEnderecoRef"
                        :rules="regras.rua"
                        v-model="transportadora.enderecos[0].rua"
                        :disabled="!permissaoAnalisaSolicitacao || model.status.id == estatusComputed.statusEnum.PROCESSAMENTO"
                        @change="alteracoes.enderecos[0].rua = true; $refs.formDadosCadastrais.validate();"
                        validate-on-blur
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs6 sm2>
                        <v-text-field label="Número*"
                        id="txtDadosCadastraisNumero"
                        ref="txtDadosCadastraisNumeroRef"
                        :rules="regras.numero"
                        v-model="transportadora.enderecos[0].numero"
                        @change="alteracoes.enderecos[0].numero = true; $refs.formDadosCadastrais.validate();"
                        :disabled="!permissaoAnalisaSolicitacao || model.status.id == estatusComputed.statusEnum.PROCESSAMENTO"
                        validate-on-blur
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs6 sm3>
                        <v-text-field label="Complemento"
                        id="txtDadosCadastraisComplemento"
                        ref="txtDadosCadastraisComplementoRef"
                        @change="alteracoes.enderecos[0].complemento = true; $refs.formDadosCadastrais.validate();"
                        v-model="transportadora.enderecos[0].complemento"
                        :disabled="!permissaoAnalisaSolicitacao || model.status.id == estatusComputed.statusEnum.PROCESSAMENTO"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm3>
                        <v-text-field label="Bairro*"
                        id="txtDadosCadastraisBairro"
                        ref="txtDadosCadastraisBairroRef"
                        :rules="regras.bairro"
                        v-model="transportadora.enderecos[0].bairro"
                        :disabled="!permissaoAnalisaSolicitacao || model.status.id == estatusComputed.statusEnum.PROCESSAMENTO"
                        @change="alteracoes.enderecos[0].bairro = true; $refs.formDadosCadastrais.validate();"
                        validate-on-blur></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm3>
                      <v-autocomplete label="UF*"
                        id="txtDadosCadastraisEstado"
                        ref="txtDadosCadastraisEstadoRef"
                        :items="listaEstados"
                        item-text="sigla"
                        item-value="sigla"
                        no-data-text= "Estado não encontrado"
                        v-model="transportadora.enderecos[0].estado"
                        :disabled="!permissaoAnalisaSolicitacao || model.status.id == estatusComputed.statusEnum.PROCESSAMENTO"
                        :rules="regras.estado"
                        @change="carregaCidadesDoEstado(transportadora.enderecos[0].estado)">
                      </v-autocomplete>
                    </v-flex>
                    <v-flex xs12 sm3>
                      <v-autocomplete label="Cidade*"
                        id="txtDadosCadastraisCidade"
                        ref="txtDadosCadastraisCidadeRef"
                        :items="listaCidades"
                        item-text="nome"
                        item-value="nome"
                        no-data-text= "Sem cidades para listar"
                        v-model="transportadora.enderecos[0].cidade"
                        @change="alteracoes.enderecos[0].cidade = true;"
                        :disabled="!permissaoAnalisaSolicitacao || model.status.id == estatusComputed.statusEnum.PROCESSAMENTO"
                        :rules="formRulesComputed.endereco.cidade(transportadora.enderecos[0].cidade)">
                      </v-autocomplete>
                    </v-flex>
                    <v-flex xs12 sm4>
                        <v-text-field label="E-mail"
                        id="txtDadosCadastraisEmail"
                        ref="txtDadosCadastraisEmailRef"
                        :value="usuario.email"
                        disabled></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm4>
                        <v-text-field label="Nome"
                        id="txtDadosCadastraisNome"
                        ref="txtDadosCadastraisNomeRef"
                        :value="usuario.nome"
                        disabled></v-text-field>
                    </v-flex>
                    <v-flex xs4 sm1>
                        <v-text-field label="DDD"
                        id="txtDadosCadastraisDdd"
                        ref="txtDadosCadastraisDddRef"
                        :value="usuario.telefones[0].ddd"
                        disabled></v-text-field>
                    </v-flex>
                    <v-flex xs8 sm3>
                        <v-text-field label="Telefone"
                        id="txtDadosCadastraisTelefone"
                        ref="txtDadosCadastraisTelefoneRef"
                        :value="usuario.telefones[0].telefone"
                        disabled></v-text-field>
                    </v-flex>
                    <v-flex xs12 v-if="permissaoAnalisaSolicitacao">
                        <v-btn :disabled="!validaAlteracoes || loadingSalvar || model.status.id == estatusComputed.statusEnum.PROCESSAMENTO"
                        id="btnDadosCadastraisSalvarTransportadora"
                        ref="btnDadosCadastraisSalvarTransportadoraRef"
                        :block="$vuetify.breakpoint.xsOnly"
                        :loading="loadingSalvar"
                        class="white--text right"
                        @click.native="salvaTransportadora"
                        color="primary">
                            Salvar
                            <v-icon right class="hidden-sm-and-down">save</v-icon>
                        </v-btn>
                    </v-flex>
                    <v-snackbar
                        :timeout="6000"
                        :color="snackbarSalvarTransportadora.sucesso ? 'success' : 'error'"
                        multi-line
                        v-model="snackbarSalvarTransportadora.visivel">
                        {{ snackbarSalvarTransportadora.mensagem }}
                        <v-btn dark flat @click.native="snackbarSalvarTransportadora.visivel = false">Fechar</v-btn>
                    </v-snackbar>
                </v-layout>
            </v-form>
        </v-container>
    </v-flex>
</template>

<script>
import axios from 'axios';
import EStatus from '@/helpers/estatus.js'
import formRules from '@/helpers/form-rules';
import permissoes from '@/helpers/permissoes.js';
import solicitacaoConsulta from '@/components/pages/solicitacao-consulta/SolicitacaoConsulta'
import usuarioHelper from '@/helpers/usuario-logado'

export default {
  name: 'dadoscadastrais',
  props: ['model'],
  data: () => {
      return {
        loadingSalvar: false,
        listaEstados: [],
        listaCidades: [],
        countCarregamentosCidade: 0,
        snackbarSalvarTransportadora: {
            sucesso: true,
            visivel: false,
            mensagem: ''
        },
        formValidDadosCadastrais: false,
        transportadora: {
            id: 0,
            cnpj: '',
            nome: '',
            enderecos: [{
                id: 0,
                cep: '',
                rua: '',
                complemento: '',
                bairro: '',
                cidade: '',
                estado: '',
                numero: ''
            }]
        },
        alteracoes: {
          nome: false,
          enderecos: [{
            cep: false,
            rua: false,
            numero: false,
            complemento: false,
            bairro: false,
            estado: false,
            cidade: false
          }]
        },
        usuario: {
            id: 0,
            email: '',
            nome: '',
            telefones: [{
                ddd: '',
                telefone: ''
            }]
        },
        usuarioAutor: {},
        regras: {
            nomeTransportadora: [
                v => !!v || 'Você não pode deixar este campo em branco'
            ],
            cep: [
                v => v == "" || v == null || v.length == 8 || 'Você precisa informar um CEP válido'
            ],
            rua: [
                v => v == "" || v == null || v.length < 255 || 'O endereço informado é muito grande'
            ],
            numero: [
                v => v == "" || v == null || /\d$/g.test(v) && parseInt(v) > 0 || 'Você precisa informar um número válido',
            ],
            bairro: [
                v => v == "" || v == null || v.length < 255 || 'O bairro informado é muito grande'
            ],
            cidade: [
                v => !!v || 'Você não pode deixar este campo em branco'
            ],
            estado: [
                v => !!v || 'Você não pode deixar este campo em branco',
                v => /[A-Z]{2}/g.test(v) || 'Você precisa informar um UF válido'
            ]
        },
        preenchimentoAutomatico: {
            rua: true,
            bairro: true,
            cidade: true,
            estado: true
        }
      }
  },
  computed: {
      permissaoAnalisaSolicitacao: function() {
        return permissoes.verificaPermissao(permissoes.SolicitacaoConsulta.ANALISA_SOLICITACAO)
      },
      cepPreenchido: function() {
          return this.transportadora.enderecos[0].cep;
      },
      estatusComputed: function() {
        return EStatus;
      },
      formRulesComputed: function() {
        return formRules;
      },
      validaAlteracoes: function () {
        if( this.alteracoes.enderecos[0].cep || this.alteracoes.enderecos[0].rua || this.alteracoes.enderecos[0].numero
            || this.alteracoes.enderecos[0].complemento || this.alteracoes.enderecos[0].bairro || this.alteracoes.enderecos[0].estado
            || this.alteracoes.enderecos[0].cidade || this.alteracoes.nome) {

              if(!this.transportadora.enderecos[0].cep && !this.transportadora.enderecos[0].rua
                  && !this.transportadora.enderecos[0].numero && !this.transportadora.enderecos[0].bairro) {
                    if(this.preenchimentoEnderecoValido && this.transportadora.nome && this.transportadora.enderecos[0].estado && this.transportadora.enderecos[0].cidade)
                      return true;
              }

              if((!this.alteracoes.enderecos[0].cep && !this.alteracoes.enderecos[0].rua && !this.alteracoes.enderecos[0].numero
                  && !this.alteracoes.enderecos[0].complemento && !this.alteracoes.enderecos[0].bairro && !this.alteracoes.enderecos[0].estado
                  && !this.alteracoes.enderecos[0].estado && !this.alteracoes.enderecos[0].cidade)
                  && (this.alteracoes.nome)){
                    if(this.preenchimentoEnderecoValido && this.transportadora.nome && this.transportadora.enderecos[0].estado && this.transportadora.enderecos[0].cidade)
                      return true;
              }
              if (this.transportadora.enderecos[0].cep && this.transportadora.enderecos[0].rua && this.transportadora.enderecos[0].numero
                  && this.transportadora.enderecos[0].bairro && this.transportadora.enderecos[0].estado && this.transportadora.enderecos[0].cidade
                  && this.transportadora.nome){

                    if (this.formValidDadosCadastrais)
                      return true;
              }
        }
        return false;
      },
      preenchimentoEnderecoValido: function () {
        if(this.alteracoes.enderecos[0].cep || this.alteracoes.enderecos[0].rua || this.alteracoes.enderecos[0].numero
            || this.alteracoes.enderecos[0].complemento || this.alteracoes.enderecos[0].bairro
            || this.alteracoes.enderecos[0].estado || this.alteracoes.enderecos[0].cidade) {
              return this.transportadora.enderecos[0].cep && this.transportadora.enderecos[0].rua && this.transportadora.enderecos[0].numero
                  && this.transportadora.enderecos[0].bairro && this.transportadora.enderecos[0].estado && this.transportadora.enderecos[0].cidade;
        }

        if(!this.transportadora.enderecos[0].cep && !this.transportadora.enderecos[0].rua && !this.transportadora.enderecos[0].numero
              && !this.transportadora.enderecos[0].bairro) {
              return true;
        }

        return true;
      },
  },
  mounted: function () {
      this.carregaDadosCadastrais();
      this.carregaEstadosBrasileiros();
  },
  methods: {
      carregaDadosGoogle: function () {
        const self = this;
        self.alteracoes.enderecos[0].cep = true;
        if(self.transportadora.enderecos[0].cep){
          axios.get(`${process.env.URL_GOOGLEMAPSAPIMS}/v1/buscacep?cep=${self.transportadora.enderecos[0].cep}`, {
              headers: { 'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}` }
          })
          .then((response) => {
              if (response) {
                self.$refs.txtDadosCadastraisNumeroRef.reset();
                self.$refs.txtDadosCadastraisComplementoRef.reset();
                self.$refs.txtDadosCadastraisEnderecoRef.reset();
                self.$refs.txtDadosCadastraisBairroRef.reset();
                self.$refs.txtDadosCadastraisCidadeRef.reset();
                self.transportadora.enderecos[0].estado = '';

                  if(response.data.length != 0) {
                    const data = response.data[0].addressComponents;

                  var rua = data.filter((obj) => {
                  return obj.types.includes('ROUTE');
                  })
                  if(rua.length != 0) {
                    self.transportadora.enderecos[0].rua = rua[0].longName;
                    self.preenchimentoAutomatico.rua = true;
                  } else {
                    self.transportadora.enderecos[0].rua = '';
                    self.preenchimentoAutomatico.rua = false;
                  }
                  var bairro = data.filter((obj) => {
                    return obj.types.includes('SUBLOCALITY');
                  })
                  if(bairro.length != 0) {
                    self.transportadora.enderecos[0].bairro = bairro[0].longName;
                    self.preenchimentoAutomatico.bairro = true;
                  } else {
                    self.transportadora.enderecos[0].bairro = '';
                    self.preenchimentoAutomatico.bairro = false;
                  }
                  var estado = data.filter((obj) => {
                    return obj.types.includes('ADMINISTRATIVE_AREA_LEVEL_1');
                  })
                  if(estado.length != 0) {
                    self.transportadora.enderecos[0].estado = estado[0].shortName;
                    self.countCarregamentosCidade = 0;
                    self.countCarregamentosCidade++;
                    self.preenchimentoAutomatico.estado = true;
                    self.carregaCidadesDoEstado(self.transportadora.enderecos[0].estado)
                    .then(function() {
                        var cidade = data.filter((obj) => {
                          return obj.types.includes('ADMINISTRATIVE_AREA_LEVEL_2');
                        })
                        if(cidade.length != 0) {
                          self.transportadora.enderecos[0].cidade = cidade[0].longName;
                          self.preenchimentoAutomatico.cidade = true;
                        } else {
                          self.transportadora.enderecos[0].cidade = '';
                          self.preenchimentoAutomatico.cidade = false;
                        }
                      }
                    )

                  } else {
                    self.transportadora.enderecos[0].estado = '';
                    self.preenchimentoAutomatico.estado = false;
                  }


                } else {
                  self.preenchimentoAutomatico.rua = false;
                  self.preenchimentoAutomatico.bairro = false;
                  self.preenchimentoAutomatico.cidade = false;
                  self.preenchimentoAutomatico.estado = false;
                }
                self.$refs.formDadosCadastrais.validate();
              }
            });
        }
      },
      carregaDadosTransportadora: function () {
          const self = this;
          return axios.get(`${process.env.URL_TRANSPORTADORAMS}/v1/buscaTransportadora?id=${self.model.idTransportadora}`, {
              headers: {
                  'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
              }
          });
      },
      carregaDadosUsuario: function () {
          const self = this;
          return axios.get(`${process.env.URL_USUARIOMS}/v1/buscaUsuarioSimplesPorId?id=${self.model.idUsuarioSolicitante}`, {
              headers: {
                  'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
              }
          });
      },
      carregaDadosUsuarioAutor: function () {
          const self = this;
          return axios.get(`${process.env.URL_USUARIOMS}/v1/buscaUsuarioSimplesPorId?id=${self.model.idUsuarioAutor}`, {
              headers: {
                  'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
              }
          });
      },
      carregaDadosCadastrais: function () {
          const self = this;
          axios.all([self.carregaDadosTransportadora(), self.carregaDadosUsuario(), self.carregaDadosUsuarioAutor()])
          .then(axios.spread(function (responseTrans, responseUsu, responseUsuAutor) {
              let objTrans = responseTrans.data;
              if (objTrans.enderecos.length == 0) {
                objTrans.enderecos = [{
                    id: 0,
                    cep: '',
                    rua: '',
                    complemento: '',
                    bairro: '',
                    cidade: '',
                    estado: '',
                    numero: '',
                }];
              }
              self.transportadora = objTrans;
              self.countCarregamentosCidade = 0;
              self.countCarregamentosCidade++;
              self.carregaCidadesDoEstado(self.transportadora.enderecos[0].estado);
              self.usuario = responseUsu.data;
              self.usuarioAutor = responseUsuAutor.data;
              self.getParentComponent('solicitacaoconsulta').transportadoraModel = self.transportadora;
              self.getParentComponent('solicitacaoconsulta').usuarioModel = self.usuario;
              self.getParentComponent('solicitacaoconsulta').usuarioAutorModel = self.usuarioAutor;
              self.getParentComponent('solicitacaoconsulta').setNomeTransportadora(self.transportadora.nome);

              self.alteracoes.nome = false;
              self.alteracoes.enderecos[0].cep = false;
              self.alteracoes.enderecos[0].rua = false;
              self.alteracoes.enderecos[0].numero = false;
              self.alteracoes.enderecos[0].complemento = false;
              self.alteracoes.enderecos[0].bairro = false;
              self.alteracoes.enderecos[0].estado = false;
              self.alteracoes.enderecos[0].cidade = false;
          }));
      },
      carregaEstadosBrasileiros: function() {
        const self = this;
        axios.get(`${process.env.URL_GEOMS}/v1/no-auth/buscaTodosEstadosSemDiversos`)
        .then((response) => {
          self.listaEstados = response.data;
        });
      },
      carregaCidadesDoEstado: async function(estadoParam) {
        const self = this;
        self.alteracoes.enderecos[0].estado = true;
        if (estadoParam && estadoParam != '') {
          if (self.transportadora.enderecos[0].cidade != '' && self.countCarregamentosCidade > 1) {
            self.transportadora.enderecos[0].cidade = '';
          }
          var estadoSelecionado = self.listaEstados.find((estado) => {
            return estado.sigla == estadoParam;
          });
          if(estadoSelecionado) {
            axios.get(`${process.env.URL_GEOMS}/v1/no-auth/buscaCidadesDeUmEstado?idestado=${estadoSelecionado.id}`)
            .then((response) => {
              self.listaCidades = response.data;
              self.countCarregamentosCidade++;
            })
            .catch((error) => {
              self.snackbarSalvarTransportadora.mensagem = error.response.data.message;
              self.snackbarSalvarTransportadora.sucesso = false;
              self.snackbarSalvarTransportadora.visivel = true;
              self.loadingSalvar = false;
            });
          }
        }
      },
      salvaTransportadora: function () {
          const self = this;
          self.loadingSalvar = true;
          axios.post(`${process.env.URL_TRANSPORTADORAMS}/v1/salvaTransportadora`, self.transportadora, {
              headers: { 'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}` } })
          .then((response) => {
              if (response.data) {
                  axios.post(`${process.env.URL_QUESTIONARIOMS}/v1/salvaRegistroAuditoria`, {
                      descricao:`Alterou dados cadastrais do cliente ${self.transportadora.nome}`,
                      usuario: usuarioHelper.USUARIO_LOGADO().nome,
                      protocolo: self.model.protocolo,
                      cliente: self.transportadora.nome
                      },
                      { headers: { 'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}` }
                  })
                  self.snackbarSalvarTransportadora.visivel = true;
                  self.snackbarSalvarTransportadora.sucesso = true;
                  self.snackbarSalvarTransportadora.mensagem = 'Os dados foram salvos com sucesso'
                  self.getParentComponent('solicitacaoconsulta').setNomeTransportadora(self.transportadora.nome);
                  self.loadingSalvar = false;
                  self.alteracoes.nome = false;
                  self.alteracoes.enderecos[0].cep = false;
                  self.alteracoes.enderecos[0].rua = false;
                  self.alteracoes.enderecos[0].numero = false;
                  self.alteracoes.enderecos[0].complemento = false;
                  self.alteracoes.enderecos[0].bairro = false;
                  self.alteracoes.enderecos[0].estado = false;
                  self.alteracoes.enderecos[0].cidade = false;
              } else {
                  self.snackbarSalvarTransportadora.sucesso = false;
                  self.snackbarSalvarTransportadora.mensagem = 'Ocorreu um erro ao salvar os dados'
                  self.loadingSalvar = false;
              }
          })
          .catch((error) => {
            self.snackbarSalvarTransportadora.mensagem = error.response.data.message;
            self.snackbarSalvarTransportadora.sucesso = false;
            self.snackbarSalvarTransportadora.visivel = true;
            self.loadingSalvar = false;
          });
          self.loadingSalvar = false;
      },
      getParentComponent: function(componentName) {
        let component = null;
        let parent = this.$parent;
        while (parent && !component) {
          if (parent.$options.name === componentName) {
            component = parent;
          }
          parent = parent.$parent;
        }
        return component;
      }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/pages/solicitacao-consulta/DadosCadastrais.vue